import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronLeft, FiChevronRight, FiStar, FiZap, FiDroplet, FiTruck, FiHome, FiScissors } = FiIcons;

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviews = [
    {
      text: "Had three new calls in the first week. Booked two jobs that paid for the page already.",
      name: "Jason Miller",
      location: "Penrith NSW",
      trade: "Electrician",
      icon: FiZap,
      time: "2 weeks ago"
    },
    {
      text: "Went from zero online presence to looking like a proper business. Booked a $1,400 job in 10 days.",
      name: "Mark O'Donnell", 
      location: "Logan QLD",
      trade: "Plumber",
      icon: FiDroplet,
      time: "1 month ago"
    },
    {
      text: "Customers now trust me before they even call. I stopped using Gumtree completely.",
      name: "Ravi Patel",
      location: "Dandenong VIC", 
      trade: "Mobile Detailer",
      icon: FiTruck,
      time: "3 weeks ago"
    },
    {
      text: "Cleaner layout, fewer time-wasters, better enquiries. It feels like I upgraded my business.",
      name: "Sarah Nguyen",
      location: "Parramatta NSW",
      trade: "House Cleaning",
      icon: FiHome,
      time: "2 months ago"
    },
    {
      text: "Worth it for the credibility alone. I finally look like a serious operator.",
      name: "Ben Harris",
      location: "Mandurah WA",
      trade: "Landscaper",
      icon: FiScissors,
      time: "1 month ago"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [reviews.length]);

  const nextReview = () => setCurrentIndex((prev) => (prev + 1) % reviews.length);
  const prevReview = () => setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  const ReviewCard = ({ review, index, isMobile = false }) => (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 h-full flex flex-col"
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex gap-0.5">
          {[1, 2, 3, 4, 5].map((star) => (
            <SafeIcon key={star} icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
          ))}
        </div>
        <span className="text-[10px] text-white/30 font-medium uppercase tracking-tighter bg-white/5 px-2 py-1 rounded">
          Verified Trade Client
        </span>
      </div>
      
      <p className="text-white mb-6 italic leading-relaxed flex-grow">"{review.text}"</p>
      
      <div className="flex items-center gap-4 border-t border-white/10 pt-4">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-600/20 border border-white/10 flex items-center justify-center flex-shrink-0">
          <SafeIcon icon={review.icon} className="w-5 h-5 text-blue-400" />
        </div>
        <div>
          <p className="text-white font-bold text-sm">{review.name}</p>
          <p className="text-white/50 text-[11px] font-medium leading-none mt-1">
            {review.location} • {review.trade}
          </p>
          <p className="text-white/30 text-[10px] mt-1">{review.time}</p>
        </div>
      </div>
    </motion.div>
  );

  return (
    <section id="proof" className="py-20 bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Results That Speak For Themselves
          </h2>
          <p className="text-xl text-white/80">
            Real trade owners booking real jobs across Australia.
          </p>
        </motion.div>

        <div className="relative">
          <div className="hidden md:grid md:grid-cols-3 gap-6">
            {[0, 1, 2].map((i) => {
              const review = reviews[(currentIndex + i) % reviews.length];
              return <ReviewCard key={`${currentIndex}-${i}`} review={review} index={i} />;
            })}
          </div>

          <div className="md:hidden">
            <ReviewCard review={reviews[currentIndex]} index={0} isMobile />
          </div>

          <button onClick={prevReview} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-full p-2 text-white hover:bg-white/20 transition-all z-10">
            <SafeIcon icon={FiChevronLeft} className="w-6 h-6" />
          </button>
          <button onClick={nextReview} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-full p-2 text-white hover:bg-white/20 transition-all z-10">
            <SafeIcon icon={FiChevronRight} className="w-6 h-6" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;